module.exports = __webpack_public_path__ + "ecf8cbc09c27710ea42c73412a8d1ddf.pdf";